import { latest as LatestVDETypes } from '@libs/waymark-video/video-descriptor-types';
import { BaseLayer } from './BaseLayer';

/**
 * A null layer that doesn't render as anything. Its main use is usually as an invisible layer that
 * other layers' positions can be parented to.
 */
export class NullLayer extends BaseLayer<LatestVDETypes.NullLayer> {
  static layerType: LatestVDETypes.NullLayer['ty'] = LatestVDETypes.LayerType.NullLayer;
}
